import styled from 'styled-components';
import {
  Breakpoint,
  DESKTOP_HEADER_HEIGHT,
  MOBILE_HEADER_HEIGHT,
  ZIndex,
} from '../../../common/styles/constants';

export const OnTapLoginContainer = styled.div`
  position: fixed;
  right: 0;
  top: ${MOBILE_HEADER_HEIGHT};
  z-index: ${ZIndex.OVERLAY};

  ${Breakpoint.SMALL} {
    top: ${DESKTOP_HEADER_HEIGHT};
  }
`;
